import { INpcItem, IGetNpcProfileResp } from '../types/fm';

export class NpcAdapter {
  static adaptForFm(data: IGetNpcProfileResp): INpcItem {
    return {
      npc_id: data.npc_info.npc_info.npc_id,
      name: data.npc_info.npc_info.meta_info.name,
      avatar: {
        url: data.npc_info.npc_info.avatar_info?.avatar_list?.[0]?.avatar_img_url || '',
      },
      npc_bg_image: {
        url:
          data.npc_info.npc_info.background_img.img_url ||
          data.npc_info.npc_info.background_img.small_thumbnail_img_url ||
          '',
        dominate_color: data.npc_info.npc_info.background_img.dominate_color,
      },
      desc: data.npc_info.npc_info.meta_info.desc,
      statistic_info: {
        linkers_count: data.npc_info.statistic_info.linkers_count,
      },
      imAccount: data.npc_info?.npc_info?.im_info?.im_account || '',
    };
  }
}
